var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full-heigth agency-set-main" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "領隊資料維護",
            visible: _vm.dialogLeaderFormVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogLeaderFormVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("leader-data", {
                attrs: { "agency-code": _vm.leaderAgecnyCode },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.dialogLeaderFormVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [_c("span", [_vm._v(_vm._s(_vm.userInfo.agencyName))])]
        ),
        _c(
          "div",
          [
            !_vm.userInfo.agencyCode ? _c("no-auth") : _vm._e(),
            _vm.userInfo.agencyCode
              ? _c(
                  "el-form",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.formLoading,
                        expression: "formLoading",
                      },
                    ],
                    ref: "dynamicValidateForm",
                    staticStyle: { position: "relative" },
                    attrs: { model: _vm.formData },
                  },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "旅行社代碼",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "agencyCode",
                                  rules: [
                                    {
                                      required: true,
                                      message: "請輸入旅行社代碼",
                                      trigger: "blur",
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { readonly: "", autocomplete: "off" },
                                  model: {
                                    value: _vm.formData.agencyCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "agencyCode", $$v)
                                    },
                                    expression: "formData.agencyCode",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "旅行社名稱",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "agencyName",
                                  rules: [
                                    {
                                      required: true,
                                      message: "請輸入旅行社名稱",
                                      trigger: "change",
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { autocomplete: "off" },
                                  model: {
                                    value: _vm.formData.agencyName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "agencyName", $$v)
                                    },
                                    expression: "formData.agencyName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "旅行社簡稱",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "agencyShortName",
                                  rules: [
                                    {
                                      required: true,
                                      message: "請輸入旅行社簡稱",
                                      trigger: "change",
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { autocomplete: "off" },
                                  model: {
                                    value: _vm.formData.agencyShortName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "agencyShortName",
                                        $$v
                                      )
                                    },
                                    expression: "formData.agencyShortName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-row",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "統一編號",
                                          "label-width": _vm.formLabelWidth,
                                          prop: "vatNumber",
                                          rules: [
                                            {
                                              required: true,
                                              message: "請輸入統一編號",
                                              trigger: "blur",
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { autocomplete: "off" },
                                          model: {
                                            value: _vm.formData.vatNumber,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "vatNumber",
                                                $$v
                                              )
                                            },
                                            expression: "formData.vatNumber",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "負責人",
                                          "label-width": _vm.formLabelWidth,
                                          prop: "boss",
                                          rules: [
                                            {
                                              required: true,
                                              message: "請輸入負責人",
                                              trigger: "blur",
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: { autocomplete: "off" },
                                          model: {
                                            value: _vm.formData.boss,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "boss",
                                                $$v
                                              )
                                            },
                                            expression: "formData.boss",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Email",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "email",
                                  rules: [
                                    {
                                      required: true,
                                      message: "請輸入Email",
                                      trigger: "blur",
                                    },
                                    {
                                      required: true,
                                      pattern: _vm.pattern.email,
                                      message: "Email格式不正確",
                                      trigger: "blur",
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { autocomplete: "off" },
                                  model: {
                                    value: _vm.formData.email,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "email", $$v)
                                    },
                                    expression: "formData.email",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "電話",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "tel",
                                  rules: [
                                    {
                                      required: true,
                                      message: "請輸入電話",
                                      trigger: "blur",
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: { autocomplete: "off" },
                                  model: {
                                    value: _vm.formData.tel,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "tel", $$v)
                                    },
                                    expression: "formData.tel",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "地址",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "addr",
                                  rules: [
                                    {
                                      required: true,
                                      message: "請輸地址",
                                      trigger: "blur",
                                    },
                                  ],
                                },
                              },
                              [
                                _c(
                                  "el-row",
                                  { staticStyle: { "margin-bottom": "22px" } },
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                        },
                                        attrs: { span: 24 },
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("el-input", {
                                              staticClass: "zipCode",
                                              staticStyle: { width: "95%" },
                                              attrs: {
                                                autocomplete: "off",
                                                readonly: true,
                                              },
                                              model: {
                                                value: _vm.zipCode,
                                                callback: function ($$v) {
                                                  _vm.zipCode = $$v
                                                },
                                                expression: "zipCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: "city",
                                              rules: [
                                                {
                                                  required: true,
                                                  message: "請選擇縣市",
                                                  trigger: "change",
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "95%" },
                                                attrs: {
                                                  filterable: "",
                                                  clearable: "",
                                                  placeholder: "請選擇縣市",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.getTaiwanCitiesOption(
                                                      2,
                                                      true
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: _vm.formData.city,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "city",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "formData.city",
                                                },
                                              },
                                              _vm._l(
                                                _vm.twCityOptions,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item,
                                                    attrs: {
                                                      label: item,
                                                      value: item,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: "site",
                                              rules: [
                                                {
                                                  required: true,
                                                  message: "請選擇行政區域",
                                                  trigger: "change",
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "95%" },
                                                attrs: {
                                                  filterable: "",
                                                  clearable: "",
                                                  placeholder: "請選擇行政區域",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.getTaiwanCitiesOption(
                                                      3,
                                                      true
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: _vm.formData.site,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "site",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "formData.site",
                                                },
                                              },
                                              _vm._l(
                                                _vm.twSiteOptions,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item,
                                                    attrs: {
                                                      label: item,
                                                      value: item,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: "road",
                                              rules: [
                                                {
                                                  required: true,
                                                  message: "請選擇路名",
                                                  trigger: "change",
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  filterable: "",
                                                  clearable: "",
                                                  placeholder: "請選擇路名",
                                                },
                                                on: {
                                                  change:
                                                    _vm.getTaiwanCitiesZipCode,
                                                },
                                                model: {
                                                  value: _vm.formData.road,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "road",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "formData.road",
                                                },
                                              },
                                              _vm._l(
                                                _vm.twRoadOptions,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item,
                                                    attrs: {
                                                      label: item,
                                                      value: item,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: { autocomplete: "off" },
                                          model: {
                                            value: _vm.formData.addr,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "addr",
                                                $$v
                                              )
                                            },
                                            expression: "formData.addr",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "付款日",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "paymentDate",
                                  rules: [
                                    {
                                      required: true,
                                      message: "請選擇付款日",
                                      trigger: "change",
                                    },
                                  ],
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      margin: "5px",
                                      width: "50%",
                                    },
                                    attrs: {
                                      disabled: true,
                                      filterable: "",
                                      clearable: "",
                                      placeholder: "請選擇付款日",
                                    },
                                    model: {
                                      value: _vm.formData.paymentDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "paymentDate",
                                          $$v
                                        )
                                      },
                                      expression: "formData.paymentDate",
                                    },
                                  },
                                  _vm._l(_vm.checkOutDates, function (item) {
                                    return _c("el-option", {
                                      key: item,
                                      attrs: { label: item, value: item },
                                    })
                                  }),
                                  1
                                ),
                                _vm._v(" 日 "),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "結帳日",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "checkOutDate",
                                  rules: [
                                    {
                                      required: true,
                                      message: "請選擇結帳日",
                                      trigger: "change",
                                    },
                                  ],
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      margin: "5px",
                                      width: "50%",
                                    },
                                    attrs: {
                                      disabled: true,
                                      filterable: "",
                                      clearable: "",
                                      placeholder: "請選擇結帳日",
                                    },
                                    model: {
                                      value: _vm.formData.checkOutDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "checkOutDate",
                                          $$v
                                        )
                                      },
                                      expression: "formData.checkOutDate",
                                    },
                                  },
                                  _vm._l(_vm.checkOutDates, function (item) {
                                    return _c("el-option", {
                                      key: item,
                                      attrs: { label: item, value: item },
                                    })
                                  }),
                                  1
                                ),
                                _vm._v(" 日 "),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "代表圖",
                                  "label-width": _vm.formLabelWidth,
                                },
                              },
                              [
                                _c(
                                  "el-row",
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        attrs: {
                                          xs: 24,
                                          sm: 24,
                                          md: 24,
                                          lg: 24,
                                          xl: 24,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              position: "relative",
                                              "margin-left": "5px",
                                              height: "100px",
                                            },
                                          },
                                          [
                                            _c("Upload", {
                                              ref: "uploadRef",
                                              staticClass: "agency-logo",
                                              attrs: {
                                                payload: _vm.formData,
                                                limitText:
                                                  "請上傳正方形圖片以利APP呈現，圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB",
                                                accept: ".jpg,.jpeg,.png",
                                                "data-obj": _vm.fileObj,
                                                "use-drag": false,
                                                action: "Agency/saveAgency",
                                                "auto-upload": false,
                                                "show-file-list": true,
                                                "form-on-loading-parent":
                                                  _vm.formLoading,
                                                "btn-txt": "上傳",
                                                "before-file-list":
                                                  _vm.formData.fileInfo &&
                                                  _vm.formData.fileInfo.length
                                                    ? _vm.formData.fileInfo[0]
                                                        .files
                                                    : [],
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "網站連結",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "bulletinBoard",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        staticStyle: {
                                          height: "auto",
                                          "white-space": "break-spaces",
                                          "font-size": "14px",
                                          margin: "5px",
                                        },
                                        attrs: { type: "warning" },
                                      },
                                      [
                                        _vm._v(
                                          "若建立旅遊團會自動帶入以下社群連結，並於該旅遊團【編輯】內可改變連結以及決定是否顯示於App"
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 19 } },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                staticClass: "web-link",
                                                attrs: {
                                                  placeholder: "請輸入官網連結",
                                                },
                                                model: {
                                                  value: _vm.formData.official,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "official",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.official",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.formData
                                                            .official,
                                                          target: "_blank",
                                                        },
                                                      },
                                                      [
                                                        _c("svg-icon", {
                                                          attrs: {
                                                            "icon-class":
                                                              "soical_Icon",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                !!_vm.formData.official
                                                  ? _c("i", {
                                                      staticClass:
                                                        "el-icon-view el-input__icon",
                                                      staticStyle: {
                                                        cursor: "pointer",
                                                      },
                                                      attrs: { slot: "suffix" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleView(
                                                            _vm.formData
                                                              .official
                                                          )
                                                        },
                                                      },
                                                      slot: "suffix",
                                                    })
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 19 } },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                staticClass: "web-link",
                                                attrs: {
                                                  placeholder:
                                                    "請輸入Line官方帳號連結",
                                                },
                                                model: {
                                                  value: _vm.formData.line,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "line",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "formData.line",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [
                                                    _c("svg-icon", {
                                                      attrs: {
                                                        "icon-class": "ic_line",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                !!_vm.formData.line
                                                  ? _c("i", {
                                                      staticClass:
                                                        "el-icon-view el-input__icon",
                                                      staticStyle: {
                                                        cursor: "pointer",
                                                      },
                                                      attrs: { slot: "suffix" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleView(
                                                            _vm.formData.line
                                                          )
                                                        },
                                                      },
                                                      slot: "suffix",
                                                    })
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 19 } },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                staticClass: "web-link",
                                                attrs: {
                                                  placeholder:
                                                    "請輸入FB粉絲團連結",
                                                },
                                                model: {
                                                  value: _vm.formData.fb,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "fb",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "formData.fb",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [
                                                    _c("svg-icon", {
                                                      attrs: {
                                                        "icon-class":
                                                          "ic_facebook",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                !!_vm.formData.fb
                                                  ? _c("i", {
                                                      staticClass:
                                                        "el-icon-view el-input__icon",
                                                      staticStyle: {
                                                        cursor: "pointer",
                                                      },
                                                      attrs: { slot: "suffix" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleView(
                                                            _vm.formData.fb
                                                          )
                                                        },
                                                      },
                                                      slot: "suffix",
                                                    })
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 19 } },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                staticClass: "web-link",
                                                attrs: {
                                                  placeholder: "請輸入IG連結",
                                                },
                                                model: {
                                                  value: _vm.formData.ig,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "ig",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "formData.ig",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [
                                                    _c("svg-icon", {
                                                      attrs: {
                                                        "icon-class": "ic_ig",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                !!_vm.formData.ig
                                                  ? _c("i", {
                                                      staticClass:
                                                        "el-icon-view el-input__icon",
                                                      staticStyle: {
                                                        cursor: "pointer",
                                                      },
                                                      attrs: { slot: "suffix" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleView(
                                                            _vm.formData.ig
                                                          )
                                                        },
                                                      },
                                                      slot: "suffix",
                                                    })
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 19 } },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                staticClass: "web-link",
                                                attrs: {
                                                  placeholder:
                                                    "請輸入Youtube連結",
                                                },
                                                model: {
                                                  value: _vm.formData.yt,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "yt",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "formData.yt",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "prepend" },
                                                  [
                                                    _c("svg-icon", {
                                                      attrs: {
                                                        "icon-class":
                                                          "ic_youtube",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                !!_vm.formData.yt
                                                  ? _c("i", {
                                                      staticClass:
                                                        "el-icon-view el-input__icon",
                                                      staticStyle: {
                                                        cursor: "pointer",
                                                      },
                                                      attrs: { slot: "suffix" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleView(
                                                            _vm.formData.yt
                                                          )
                                                        },
                                                      },
                                                      slot: "suffix",
                                                    })
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          position: "absolute",
                          right: "10px",
                          bottom: "10px",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#4b4b4b" },
                            attrs: { type: "warning" },
                            on: {
                              click: function ($event) {
                                return _vm.saveData("dynamicValidateForm")
                              },
                            },
                          },
                          [_vm._v("儲 存")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }